import { Download } from "components/icons/generated";
import Button from "ds/components/Button";
import { AspectType } from "types/generated";

import { showCSVDownloadDrawer } from "./Drawer";

type CSVDownloadDrawerButtonProps = {
  aspectType: AspectType;
};

const CSVDownloadDrawerButton = ({ aspectType }: CSVDownloadDrawerButtonProps) => (
  <Button
    variant="secondary"
    startIcon={Download}
    onPress={() => showCSVDownloadDrawer({ aspectType })}
  >
    Export CSV
  </Button>
);

export default CSVDownloadDrawerButton;
